import { render, staticRenderFns } from "./AssignSkillSetDialog.vue?vue&type=template&id=4d8b94d6"
import script from "./AssignSkillSetDialog.ts?vue&type=script&lang=ts&external"
export * from "./AssignSkillSetDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AssignSkillSetDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports